import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import FormComponent from 'modules/core/components/Form'
import { useEffect } from 'modules/core/hooks/useEffect'

import type { Action } from 'modules/automations/store/models/Action'

import { AutomationStep } from '../Step'
import { automationSteps } from '../Step/constants'
import { getActionName } from '../actionUtils'
import Selects from './Selects'

interface Props {
  action: Action
  form: Form | undefined
  onClick?: () => void
  withLastSpacer?: boolean
}

export const SendNotificationAction = observer(
  ({ action, form, onClick, withLastSpacer }: Props) => {
    const isDefault = action.automation ? action.automation.isDefault : true
    const { notifiable_id, recipient } = form?.data() as unknown as {
      notifiable_id: string
      recipient: string
    }
    useEffect(() => {
      return () => {
        form?.setValues({
          recipient: null,
          notifiable_id: null,
        })
      }
    }, [])

    const validRecipient = !!recipient || notifiable_id

    return (
      <AutomationStep
        action={action}
        disabled={isDefault}
        onClick={onClick}
        conflict={!validRecipient}
        stepType={automationSteps.action}
        withLastSpacer={withLastSpacer}
        title={getActionName(action)}
      >
        <Box paddingX="s16" paddingBottom="s16">
          <FormComponent>
            {form && <Selects action={action} disabled={isDefault} form={form} />}
          </FormComponent>
        </Box>
      </AutomationStep>
    )
  }
)
